import { notifyUpdateAvailable } from './appUpdateState.js'

const CHUNK_LOAD_PATTERNS = [
  'failed to fetch dynamically imported module',
  'loading chunk',
  'importing a module script failed',
  'error loading dynamically imported module',
]

let triggered = false

export function isChunkLoadError(reason) {
  const message = extractMessage(reason).toLowerCase()
  if (!message) return false
  return CHUNK_LOAD_PATTERNS.some((pattern) => message.includes(pattern))
}

function extractMessage(reason) {
  if (!reason) return ''
  if (typeof reason === 'string') return reason
  if (reason instanceof Error) return reason.message
  if (typeof reason.message === 'string') return reason.message
  return String(reason)
}

function handleChunkLoadFailure() {
  if (triggered) return
  triggered = true
  notifyUpdateAvailable()
}

export function registerChunkLoadRecovery() {
  const onUnhandledRejection = (event) => {
    if (isChunkLoadError(event.reason)) {
      handleChunkLoadFailure()
    }
  }

  const onError = (event) => {
    if (isChunkLoadError(event.error ?? event.message)) {
      handleChunkLoadFailure()
    }
  }

  window.addEventListener('unhandledrejection', onUnhandledRejection)
  window.addEventListener('error', onError)

  return () => {
    window.removeEventListener('unhandledrejection', onUnhandledRejection)
    window.removeEventListener('error', onError)
  }
}
